import { Dialog, DialogTitle, DialogContent, DialogActions, Stack, Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningIcon from '@mui/icons-material/WarningAmberRounded';
import { AppBaseButton } from 'components/AppBaseButton/AppBaseButton';
import { ReactElement } from 'react';

type ConfirmationDialogProps = {
  isOpen: boolean;
  isFullscreen: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  title: string;
  titleIcon?: ReactElement;
  questionText: string;
  cancelText?: string;
  confirmText: string;
  showWarningIcon?: boolean;
};

export function ConfirmationDialog({
  isOpen,
  isFullscreen,
  handleClose,
  handleConfirm,
  title,
  titleIcon,
  questionText,
  cancelText,
  confirmText,
  showWarningIcon,
}: ConfirmationDialogProps): ReactElement {
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      fullWidth={true}
      maxWidth={'xs'}
      fullScreen={isFullscreen}
      BackdropProps={{ appear: false }}
      TransitionProps={{ appear: false }}
    >
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row" alignItems="center" spacing={1}>
            {titleIcon && titleIcon}
            {showWarningIcon && <WarningIcon />}
            <Box component="span" sx={{ pt: '0.3rem' }}>
              {title}
            </Box>
          </Stack>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <Typography>{questionText}</Typography>
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        {cancelText && (
          <AppBaseButton variant="outlined" onClick={handleClose}>
            {cancelText}
          </AppBaseButton>
        )}
        <AppBaseButton variant="contained" onClick={handleConfirm}>
          {confirmText}
        </AppBaseButton>
      </DialogActions>
    </Dialog>
  );
}
